/**
 * How a run's links are drawn on the canvas, by the runner's own rule
 * (`workflowLinkTaken`): a link the run went down is lit, the one into a
 * running step flows, and a link it can no longer take (its step skipped, or
 * a Condition that went the other way) fades. A Condition whose Yes and No
 * both lead to one step lights only the outlet it chose.
 *
 * @module components/workflows/canvas/runPath
 */
import type { WorkflowGraph, WorkflowStepRun } from "@amoreg/contracts";
import { workflowLinkNotTaken, workflowLinkTaken } from "@repo/shared/workflowGraph";

import type { EdgeRunState } from "./edges";

export function edgeRunStates(
  graph: Pick<WorkflowGraph, "edges">,
  steps: ReadonlyMap<string, WorkflowStepRun>,
): ReadonlyMap<string, EdgeRunState> {
  const states = new Map<string, EdgeRunState>();
  for (const edge of graph.edges) {
    const source = steps.get(edge.source);
    const target = steps.get(edge.target)?.status;
    const facts = source ? { status: source.status, chosenHandles: source.chosenHandles ?? null } : undefined;
    if (target === "skipped" || workflowLinkNotTaken(edge, facts)) states.set(edge.id, "skipped");
    else if (workflowLinkTaken(edge, facts) && target === "running") states.set(edge.id, "flowing");
    else if (workflowLinkTaken(edge, facts) && target !== undefined && target !== "pending") states.set(edge.id, "travelled");
  }
  return states;
}
